import { render } from "./RadioListElement.vue?vue&type=template&id=2d87440e&scoped=true&ts=true"
import script from "./RadioListElement.vue?vue&type=script&lang=ts"
export * from "./RadioListElement.vue?vue&type=script&lang=ts"

import "./RadioListElement.vue?vue&type=style&index=0&id=2d87440e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d87440e"]])

export default __exports__